exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-message[data-v-373cdd20] {\n  display: flex;\n  align-items: center;\n}\n.info-message i[data-v-373cdd20] {\n  padding-right: 15px;\n}\n.info-message p[data-v-373cdd20] {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n/* Match form-control border on CKEditor containers */\n.log-form-ckeditor[data-v-373cdd20] .editor-container {\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n.fa-exclamation-small[data-v-373cdd20] {\n  transform: scale(0.6);\n  left: -2.6px !important;\n}\n.text-600[data-v-373cdd20] {\n  font-weight: 600;\n}\n", ""]);

// exports
